// Same value the server stores for legacy items whose author is gone from the CRM.
export const SHARED_TEAM = '@shared';

export function teamLabel(team: string | null | undefined, empty = 'не назначена'): string {
  if (!team) return empty;
  return team === SHARED_TEAM ? 'Общее' : team;
}
